import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Opportunity } from '@app/shared/interfaces/lib/opportunity.interface';
import { OpportunitiesService } from '@app/shared/services/opportunities/opportunities.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

enum OpportunityView {
  LIST = 'list',
  DETAILS = 'details',
  SUCCESS = 'success',
}

@Component({
  selector: 'sbnb-dialog-property-opportunities',
  templateUrl: './dialog-property-opportunities.component.html',
  styleUrls: ['./dialog-property-opportunities.component.scss'],
})
export class DialogPropertyOpportunitiesComponent implements OnInit {
  opportunities: Opportunity[] = [];
  loading = true;
  currentView = OpportunityView.LIST;
  selectedOpportunity: Opportunity | null = null;
  OpportunityView = OpportunityView;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { propertyId: number },
    private dialogRef: MatDialogRef<DialogPropertyOpportunitiesComponent>,
    private opportunitiesService: OpportunitiesService,
    private toastNotificationsService: ToastNotificationsService
  ) {}

  ngOnInit(): void {
    this.loadOpportunities();
  }

  loadOpportunities(): void {
    this.loading = true;
    this.opportunitiesService.getOpportunities(this.data.propertyId).subscribe(
      (response) => {
        // Filter out opportunities with input fields for now
        this.opportunities = response.data.filter((opp) => !opp.input_fields?.length);
        this.loading = false;
      },
      (error) => {
        console.error('Error loading opportunities:', error);
        this.loading = false;
        this.toastNotificationsService.error('Failed to load opportunities');
      }
    );
  }

  showOpportunityDetails(opportunity: Opportunity): void {
    this.selectedOpportunity = opportunity;
    this.currentView = OpportunityView.DETAILS;
  }

  applyOpportunity(): void {
    if (!this.selectedOpportunity) return;

    this.loading = true;
    this.opportunitiesService.applyOpportunity(this.data.propertyId, this.selectedOpportunity.id).subscribe(
      () => {
        this.loading = false;
        this.currentView = OpportunityView.SUCCESS;
      },
      (error) => {
        console.error('Error applying opportunity:', error);
        this.loading = false;
        this.toastNotificationsService.error('Failed to apply opportunity');
      }
    );
  }

  applyMore(): void {
    this.currentView = OpportunityView.LIST;
    this.selectedOpportunity = null;
    this.loadOpportunities();
  }

  close(): void {
    this.dialogRef.close();
  }
}
